import { ADD_TO_CART, DELETE_FROM_CART } from "../actions/types";

const iniitalState = {
  cart: [],
};

export default function (state = iniitalState, action) {
  const { type, payload } = action;
  switch (type) {
    case ADD_TO_CART:
      return {
        ...state,
        cart: [...state.cart, payload],
      };
    case DELETE_FROM_CART:
      return {
        ...state,
        cart: state.cart.filter((item) => item.id !== payload),
      };
    default:
      return state;
  }
}
